import React, { Component } from "react";
import { Input, Button, Form, notification } from "antd";
import { connect } from "react-redux";
import moment from "moment";
import { alert } from "../../../common/utils/alert";
import { apiAuth } from "../../../api/api-auth";
import {
  clearAuth,
  updateAuthData,
} from "../../../common/actions/actions-auth";
import { emitter } from "../../../common/utils/emitter";
import { ChangePassword } from "./components/modal/change-password";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      disableLogin: false,
    };
  }

  onChangeText = (feild, value) => {
    this.setState({ [feild]: value });
  };

  login = () => {
    const { history, dispatch } = this.props;
    this.form
      .validateFields()
      .then(async (values) => {
        try {
          const { username, password } = values;
          this.setState({ disableLogin: true });
          const loginResult = await apiAuth.login(
            username.toLowerCase().trim(),
            password
          );
          if (loginResult.status === "success") {
            const { data } = loginResult;
            this.setState({ disableLogin: false });
            // if (!data.roles.includes('Admin') && !data.roles.includes('Sale')) {
            //   return alert('error', 'Tài khoản của bạn không đúng với quyền Admin hoặc Sale')
            // }

            if (data.roles.includes("Driver")) {
              return notification.error({
                message:
                  "Tài khoản của bạn chưa được cấp quyền truy cập. Vui lòng liên hệ quản trị viên",
                duration: 3,
              });
            }

            if (data.first_time_login) {
              return this.changePassWord.visiableModal(
                true,
                username.toLowerCase(),
                () => {
                  emitter.emit("LOADED", true);
                  dispatch(
                    updateAuthData({
                      ...data,
                    })
                  );
                  if (
                    !data.roles.includes("Admin") &&
                    !data.roles.includes("Sale") &&
                    !data.roles.includes("Superuser")
                  ) {
                    history.push("/notification");
                  } else {
                    history.push("/");
                  }
                  this.setState({ disableLogin: false });
                }
              );
            }
            emitter.emit("LOADED", true);
            dispatch(
              updateAuthData({
                ...data,
              })
            );
            if (
              !data.roles.includes("Admin") &&
              !data.roles.includes("Sale") &&
              !data.roles.includes("Superuser")
            ) {
              history.push("/notification");
            } else {
              history.push("/");
            }
          } else {
            this.setState({ disableLogin: false });
            return alert("error", loginResult.data.message);
          }
        } catch (error) {
          this.setState({ disableLogin: false });
          // return alert('error', 'Network Error')
        }
      })
      .catch((info) => {});
  };

  onKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.login();
      event.preventDefault();
    }
  };

  render() {
    const { disableLogin } = this.state;
    return (
      <div className="login-route">
        <div className="login-card box-shadow">
          <div className="card-body">
            <div className="logo-text" style={{ position: "relative" }}>
              AVIS
              <span style={{ fontSize: 20, position: "absolute", top: 10 }}>
                ®
              </span>
            </div>
            <Form ref={(ref) => (this.form = ref)} layout="vertical">
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Tên đăng nhập là bắt buộc",
                  },
                ]}
                name="username"
                label="Tên đăng nhập"
              >
                <Input
                  onKeyDown={this.onKeyDown}
                  className="input"
                  placeholder="Tên đăng nhập"
                />
              </Form.Item>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Mật khẩu là bắt buộc",
                  },
                  () => ({
                    validator(rule, value) {
                      if (value && (value.length < 8 || value.length > 100)) {
                        return Promise.reject(
                          "Vui lòng kiểm tra lại Mật khẩu phải có ít nhất 8 kí tự!"
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                name="password"
                label="Mật khẩu"
              >
                <Input
                  onKeyDown={this.onKeyDown}
                  type="password"
                  className="input"
                  placeholder="Mật khẩu"
                />
              </Form.Item>
            </Form>
            <Button
              disabled={disableLogin}
              onClick={this.login}
              className="login-button"
            >
              Đăng nhập
            </Button>
          </div>
          <img
            alt=""
            className="card-body logo"
            src={require("../../../assets/images/login-image.png")}
          />
        </div>
        <ChangePassword ref={(ref) => (this.changePassWord = ref)} />
      </div>
    );
  }
}

export default connect()(Login);
